import { RotateCw } from 'lucide-react';
import { useRouteError } from 'react-router';
import { Button } from '@/design-system/components/button';

const CHUNK =
  /dynamically imported module|Importing a module script failed|Failed to fetch|error loading dynamically/i;

/**
 * Erro numa tela: em vez de página quebrada, uma mensagem e "Tentar de novo".
 * Se for uma versão nova publicada (arquivos trocados), recarrega sozinho uma vez.
 */
export function RouteError() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : '';
  if (CHUNK.test(message)) {
    try {
      if (!sessionStorage.getItem('cw.reloaded')) {
        sessionStorage.setItem('cw.reloaded', '1');
        window.location.reload();
        return null;
      }
    } catch {
      /* sem armazenamento: mostra a mensagem */
    }
  }
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="text-[18px] font-semibold">Algo deu errado nesta tela</p>
      <p className="max-w-sm text-[14px] text-fg-muted">
        {CHUNK.test(message)
          ? 'Uma versão nova do WorkFlow foi publicada.'
          : 'Tente de novo. Se continuar, avise a equipe.'}
      </p>
      <Button
        className="mt-2"
        onClick={() => {
          try {
            sessionStorage.removeItem('cw.reloaded');
          } catch {
            /* ignora */
          }
          window.location.reload();
        }}
      >
        <RotateCw /> Recarregar
      </Button>
    </div>
  );
}
